'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n'], ['\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n\tposition: relative;\n\tvertical-align: sub;\n\tdisplay: ', ';\n\twidth: ', ';\n\theight: ', ';\n\tmargin: ', ';\n\tborder-width: ', ';\n\tborder-style: solid;\n\tborder-top-color: ', ';\n\tborder-left-color: ', ';\n\tborder-right-color: ', ';\n\tborder-bottom-color: ', ';\n\tborder-radius: 100%;\n\tanimation: ', ' 0.6s linear infinite;\n'], ['\n\tposition: relative;\n\tvertical-align: sub;\n\tdisplay: ', ';\n\twidth: ', ';\n\theight: ', ';\n\tmargin: ', ';\n\tborder-width: ', ';\n\tborder-style: solid;\n\tborder-top-color: ', ';\n\tborder-left-color: ', ';\n\tborder-right-color: ', ';\n\tborder-bottom-color: ', ';\n\tborder-radius: 100%;\n\tanimation: ', ' 0.6s linear infinite;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

/*--------------------------
    Style Variables
--------------------------*/
var TopbarZIndex = 9999940;
var ModalDefaultZIndex = 9999950;

/*--------------------------
    Style Keyframes
--------------------------*/
var rotate360 = (0, _styledComponents.keyframes)(_templateObject);

/*--------------------------
    Style Component
--------------------------*/
var Spin = _styledComponents2.default.div(_templateObject2, function (props) {
	return props.display ? props.display : 'inline-block';
}, function (props) {
	return props.size ? props.size : '20px';
}, function (props) {
	return props.size ? props.size : '20px';
}, function (props) {
	return props.margin ? props.margin : '0 auto';
}, function (props) {
	return props.borderWidth ? props.borderWidth : '2px';
}, function (props) {
	return props.bgColor ? props.bgColor : 'transparent';
}, function (props) {
	return props.bgColor ? props.bgColor : 'transparent';
}, function (props) {
	return props.color ? props.color : _colors2.default.Red;
}, function (props) {
	return props.color ? props.color : _colors2.default.Red;
}, rotate360);

var GlobalStyle = {
	/*--------------------------
 	Variables
 --------------------------*/
	TopbarZIndex: TopbarZIndex,
	ModalDefaultZIndex: ModalDefaultZIndex,

	/*--------------------------
 	Component
 --------------------------*/
	Spin: Spin
};

exports.default = GlobalStyle;
module.exports = exports['default'];